<template>
  <button
    class="primary-btn"
    :type="type"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot>{{ label }}</slot>
    <span v-if="showArrow" class="btn-arrow" aria-hidden="true">→</span>
  </button>
</template>

<script>
export default {
  name: 'PrimaryButton',
  props: {
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'button',
      validator: (value) => ['button', 'submit', 'reset'].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['click'],
}
</script>

<style scoped>
.primary-btn {
  width: 100%;
  min-height: 60px;
  border: 1px solid rgba(239, 148, 32, 0.16);
  border-radius: 18px;
  background: linear-gradient(180deg, #ffc52a 0%, #f2b400 100%);
  color: #1f2a15;
  font-size: 18px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-shadow: 0 16px 30px rgba(242, 180, 0, 0.28),
    0 4px 10px rgba(68, 85, 38, 0.08);
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

.primary-btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.primary-btn:focus {
  outline: none;
  box-shadow: 0 0 0 4px rgba(252, 196, 21, 0.22),
    0 16px 30px rgba(242, 180, 0, 0.28), 0 4px 10px rgba(68, 85, 38, 0.08);
}

.primary-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none;
}

.btn-arrow {
  font-size: 18px;
  line-height: 1;
}
</style>
